module.exports = __webpack_public_path__ + "img/gl.a9d95f04.svg";